import React from 'react';

const Card = ({children, ...props}) => {

    // - - - - - - - - - - - - - - - - - - - - - - - - -

    // ==================================================
    // ==================================================
    return(
        <div 
            className={props.card_classes + " shadow-lg border rounded-lg lg:rounded-2xl p-4 overflow-hidden"}
        >
            {children}
        </div>
    );
};

export default Card;